var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { createIcon } from '../../../../_common/components/icon/uni-icon.js';
import { BaseCellRenderer } from '../base-cell.js';
import { columnRenderer, createFromBaseCellRenderer } from '../renderer.js';
import { ImageColumnTypeName, imagePureColumnConfig } from './define.js';
let TextCell = class TextCell extends BaseCellRenderer {
    render() {
        return html `<img src=${this.value ?? ''}></img>`;
    }
};
TextCell.styles = css `
    affine-database-image-cell {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
    }
    affine-database-image-cell img {
      width: 20px;
      height: 20px;
    }
  `;
TextCell = __decorate([
    customElement('affine-database-image-cell')
], TextCell);
export { TextCell };
columnRenderer.register({
    type: ImageColumnTypeName,
    icon: createIcon('ImageIcon'),
    cellRenderer: {
        view: createFromBaseCellRenderer(TextCell),
    },
});
export const imageColumnConfig = imagePureColumnConfig;
//# sourceMappingURL=cell-renderer.js.map